var _circle, _path, _circle2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    transform: "matrix(-1 0 0 1 30 -0.000244141)",
    fill: "white",
    stroke: "url(#paint0_linear_2644_19214)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1429 14.6859V15.6449H13.8409V19.5999H12.6439V15.6449H11.3419V14.6859H15.1429ZM18.1237 15.6519C18.581 15.6519 18.945 15.8012 19.2157 16.0999C19.491 16.3939 19.6287 16.7999 19.6287 17.3179V19.5999H18.4387V17.4789C18.4387 17.2175 18.371 17.0145 18.2357 16.8699C18.1003 16.7252 17.9183 16.6529 17.6897 16.6529C17.461 16.6529 17.279 16.7252 17.1437 16.8699C17.0083 17.0145 16.9407 17.2175 16.9407 17.4789V19.5999H15.7437V15.6939H16.9407V16.2119C17.062 16.0392 17.2253 15.9039 17.4307 15.8059C17.636 15.7032 17.867 15.6519 18.1237 15.6519Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3002,
    cy: 8.1,
    r: 1.6,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0366 10.8H19.9638L22.8002 16.8V22.8H7.2002V16.8L10.0366 10.8Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2644_19214",
    x1: 1.05132e-9,
    y1: 15.0242,
    x2: 30,
    y2: 14.9758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.755380e3bf2bac754b99a0c3108327cf.svg";
export { ForwardRef as ReactComponent };